angular.module('unergie.main')
.controller('fslModalCtrl', ($scope, $uibModalInstance, $filter, account, fsl, DataAccess, AlertManager, ErrorCatcher) => {
    $scope.close = $uibModalInstance.dismiss

    $scope.modif = !!fsl

    $scope.fslPayload = {
        request_date: fsl && fsl.request_date ? new Date(fsl.request_date) : new Date(),
        response_date: fsl && fsl.response_date ? new Date(fsl.response_date) : null,
        receipt_date: fsl && fsl.receipt_date ? new Date(fsl.receipt_date) : null,
        status: fsl ? fsl.status : 'REQUESTED',
        external_id: fsl ? fsl.external_id : '',
        id_account: account.id,
    }

    $scope.possibleStatus = [
        { value: 'REQUESTED', label: 'Demandé' },
        { value: 'GRANTED', label: 'Accordé' },
        { value: 'REJECTED', label: 'Refusé' },
        { value: 'RECEIVED', label: 'Paiement reçu' },
    ]

    $scope.statusChanged = () => {
        switch ($scope.fslPayload.status) {
            case ('GRANTED'):
            case ('REJECTED'):
                $scope.fslPayload.response_date = fsl && fsl.response_date ? new Date(fsl.response_date) : new Date()
                break
            case ('RECEIVED'):
                $scope.fslPayload.receipt_date = fsl && fsl.receipt_date ? new Date(fsl.receipt_date) : new Date()
                break
            default:
                break
        }
    }

    $scope.isValidityDateOk = () => {
        return $scope.fslPayload.request_date && moment($scope.fslPayload.request_date).isAfter(moment().add(-1, 'month'))
    }

    $scope.canSave = () => {
        return !!$scope.fslPayload.request_date &&
            (!!$scope.fslPayload.response_date || $scope.fslPayload.status === 'REQUESTED') &&
            (!!$scope.fslPayload.receipt_date || $scope.fslPayload.status !== 'RECEIVED')
    }

    $scope.save = () => {
        $scope.saving = true
        const payload = _.cloneDeep($scope.fslPayload)
        payload.request_date = payload.request_date && moment(payload.request_date).format('YYYY-MM-DD')
        payload.response_date = payload.response_date && moment(payload.response_date).format('YYYY-MM-DD')
        payload.receipt_date = payload.receipt_date && moment(payload.receipt_date).format('YYYY-MM-DD')
        if ($scope.modif) {
            return DataAccess.updateFsl({ id: fsl.id }, payload).$promise.then(() => {
                AlertManager.success('Demande de FSL mise à jour')
                $scope.done()
            }).catch(ErrorCatcher)
            .finally(() => {
                $scope.saving = false
            })
        }
        return DataAccess.saveFsl(payload).$promise.then(() => {
            AlertManager.success('Demande de FSL enregistrée')
            $scope.done()
        }).catch(ErrorCatcher)
        .finally(() => {
            $scope.saving = false
        })
    }

    $scope.done = $uibModalInstance.close
})
